import React from 'react';
import './SpendingSummary.css';

const SpendingSummary = ({ summary, employeeName, startDate, endDate }) => {
  const formatCurrency = (amount) => {
    return `R ${parseFloat(amount).toFixed(2)}`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-ZA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="spending-summary">
      <div className="summary-header">
        <h2>Spending Summary</h2>
        {employeeName && <p className="employee-name">{employeeName}</p>}
        <p className="date-range">
          {formatDate(startDate)} - {formatDate(endDate)}
        </p>
      </div>
      
      <div className="summary-cards">
        <div className="summary-card transaction-count">
          <div className="card-icon">📊</div>
          <div className="card-content">
            <h3>Total Transactions</h3>
            <p className="count">{summary.transactionCount || 0}</p>
          </div>
        </div>

        <div className="summary-card total-spent2">
          <div className="card-icon">💰</div>
          <div className="card-content">
            <h3>Total Spent</h3>
            <p className="amount">{formatCurrency(summary.totalSpent || 0)}</p>
          </div>
        </div>
        
        <div className="summary-card average-spent">
          <div className="card-icon">📈</div>
          <div className="card-content">
            <h3>Average per Transaction</h3>
            <p className="amount">{formatCurrency(summary.averagePerTransaction || 0)}</p>
          </div>
        </div>
        
        <div className="summary-card unique-items">
          <div className="card-icon">🛍️</div>
          <div className="card-content">
            <h3>Unique Items</h3>
            <p className="count">{summary.uniqueItems || 0}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpendingSummary;